/* eslint-disable react/no-danger */
import React from 'react';
import classNames from 'classnames';
import { isString, isError } from 'lodash';
import { ExternalLink } from 'react-omni-link';
import ErrorComponent from './ErrorComponent';
import './index.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var hasNoAccountAuth = '您没有任何云上百度权限，请<a href="/profile/initiate/joinUserGroups">申请权限</a>';
/* bca-disable */

function renderError(error, hasAccount) {
  if (error === 'Forbidden') {
    return /*#__PURE__*/_jsxs("p", {
      children: ["\u65E0\u8D44\u6E90\u67E5\u770B\u6743\u9650\uFF0C \u8BF7\u5148\u5C1D\u8BD5", /*#__PURE__*/_jsx(ExternalLink, {
        to: "/profile/initiate/joinUserGroups",
        children: "\u7533\u8BF7\u6743\u9650"
      }), "\uFF0C\u5982\u8FD8\u6709\u95EE\u9898\uFF0C\u8BF7\u52A0\u5982\u6D41\u7FA4 2117081 \u53CD\u9988"]
    });
  }

  if (isString(error)) {
    return /*#__PURE__*/_jsx("p", {
      dangerouslySetInnerHTML: {
        __html: error.startsWith('当前登录已超时') && !hasAccount ? hasNoAccountAuth : error
      }
    });
  }

  if (isError(error)) {
    return error.message;
  }

  return error;
}

function Error(_ref) {
  var _window$__icloud__, _window$__icloud__$st;

  var className = _ref.className,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'page' : _ref$position,
      error = _ref.error,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'error' : _ref$type;
  // @ts-ignore
  // eslint-disable-next-line
  var hasAccount = (_window$__icloud__ = window.__icloud__) === null || _window$__icloud__ === void 0 ? void 0 : (_window$__icloud__$st = _window$__icloud__.store) === null || _window$__icloud__$st === void 0 ? void 0 : _window$__icloud__$st.getState().detail.hasAccount;
  return /*#__PURE__*/_jsx("div", {
    className: classNames('icloud-ui-error-icon', 'icloud-ui-error-icon-' + position, 'icloud-ui-error-' + type, className),
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(ErrorComponent, {}), !!error && /*#__PURE__*/_jsx("div", {
        className: "icloud-ui-error-tip",
        children: renderError(error, hasAccount)
      })]
    })
  });
}

Error.displayName = "Error";
export default Error;
//# sourceMappingURL=es/index.js.map